import { NgModule } from '@angular/core';
import { QuickSearchRoutingModule } from './quick-search-routing.module';
import { QuickSearchHomeComponent } from './quick-search-home/quick-search-home.component';
import { QuickSearchResultsComponent } from './quick-search-results/quick-search-results.component';
import { ConfirmSubmitPaymentComponent } from './dialog/confirm-submit-payment.component';
import { ErrorMessagesComponent } from './dialog/error-messages.component';
import { SharedModule } from '../shared/shared.module';
import { ConfirmAddTaxComponent } from './dialog/confirm-add-tax.component';
import { ConfirmEnableScreenNegativePaymentComponent } from './dialog/confirm-enable-screen-negative-payment.component';
import { ConfirmRemoveTaxComponent } from './dialog/confirm-remove-tax.component';
import { InvalidRefundNoticeComponent } from './dialog/invalid-refund-notice.component';
import { NotifyNoTaxOnlyComponent } from './dialog/notify-no-tax-only.component';
import { NotifyTaxOnlyComponent } from './dialog/notify-tax-only.component';
import { ConfirmNegativePaymentComponent } from './dialog/confirm-negative-payment.component';
import { ConfirmRefundComponent } from './dialog/confirm-refund.component';
import { SendInvoicesComponent } from '../sandbox/invoice/send-invoices/send-invoices.component';

@NgModule({
  imports: [QuickSearchRoutingModule, SharedModule, SendInvoicesComponent],
  declarations: [
    QuickSearchHomeComponent,
    QuickSearchResultsComponent,
    ConfirmSubmitPaymentComponent,
    ConfirmAddTaxComponent,
    ConfirmEnableScreenNegativePaymentComponent,
    ConfirmNegativePaymentComponent,
    ConfirmRemoveTaxComponent,
    InvalidRefundNoticeComponent,
    NotifyNoTaxOnlyComponent,
    NotifyTaxOnlyComponent,
    ErrorMessagesComponent,
    ConfirmRefundComponent,
  ],
})
export class QuickSearchModule {}
